var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseModal',{attrs:{"no-exit":"","no-toolbar":"","card-width":"490px"},scopedSlots:_vm._u([{key:"default",fn:function(){return [(_vm.currentStep === 1)?_c('SpyderUpsell',{on:{"nextStep":_vm.nextStep}}):_c('ReviewOffer',{on:{"complete":function($event){return _vm.$emit('close')}}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }